import * as moment from 'moment';
import { defaultChartConfig } from '../chart.config';

export const configLineChart = {
  lineChartOptions: {
    ...defaultChartConfig,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            callback(value) {
              if (Math.floor(value) === value) {
                return value;
              }
            }
          },
          gridLines: {
            borderDash: [5, 5]
          }
        }
      ],
      xAxes: [
        {
          type: 'time',
          time: {
            unit: 'hour',
            displayFormats: {
              hour: 'HH:mm'
            }
          },
          gridLines: {
            display: false
          }
          // ticks: {
          //   callback(value, index) {
          //     console.log({ value, index });
          //     if (!index) {
          //       return moment(value).format('DD. MMM');
          //     }
          //     return moment(value).format('HH:mm');
          //   },
          //   fontSize: 11.5,
          //   maxRotation: 0
          // }
        }
      ]
    },
    elements: {
      line: {
        borderWidth: 3,
        hoverBorderWidth: 5
      },
      point: {
        radius: 0,
        borderWidth: 4,
        hitRadius: 20,
        hoverRadius: 4,
        hoverBorderWidth: 6
      }
    }
  },
  lineChartType: 'line'
};
